var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleteSynchronously(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 12.5,
    viewBox: "0 0 19.5 12.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u540C\\u6B65\\u5B8C\\u6210",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4_2\\u5907\\u4EFD_4",
    "data-name": "\\u7F16\\u7EC4 2\\u5907\\u4EFD 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M3.649,11A3.53,3.53,0,0,1,.906,9.838,3.763,3.763,0,0,1,0,7.341,3.293,3.293,0,0,1,3.184,3.868a4.012,4.012,0,0,1,1.128-2.45A4.8,4.8,0,0,1,7.716,0a4.268,4.268,0,0,1,3.946,2.509q.176-.013.353-.013A3.978,3.978,0,0,1,16,6.706a4.38,4.38,0,0,1-1.077,2.94A4.266,4.266,0,0,1,11.637,11Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(9 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_142",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#f6b04a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    "data-name": "\\u7F16\\u7EC4",
    transform: "translate(9 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_142-2",
    "data-name": "\\u692D\\u5706_142",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#329a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_13106",
    transform: "translate(1.805 5.381) rotate(-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_13240",
    width: 5.333,
    height: 0.667,
    rx: 0.333,
    transform: "translate(0.438 2.6)",
    fill: "#fbfafb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_15628",
    width: 0.714,
    height: 2.714,
    rx: 0.357,
    transform: "translate(0.286 0.333)",
    fill: "#fbfafb"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteSynchronously);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOS41IiBoZWlnaHQ9IjEyLjUiIHZpZXdCb3g9IjAgMCAxOS41IDEyLjUiPgogIDxnIGlkPSLlkIzmraXlrozmiJAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSAwLjUpIj4KICAgIDxnIGlkPSLnvJbnu4RfMuWkh+S7vV80IiBkYXRhLW5hbWU9Iue8lue7hCAy5aSH5Lu9IDQiPgogICAgICA8cGF0aCBpZD0i6Lev5b6EIiBkPSJNMy42NDksMTFBMy41MywzLjUzLDAsMCwxLC45MDYsOS44MzgsMy43NjMsMy43NjMsMCwwLDEsMCw3LjM0MSwzLjI5MywzLjI5MywwLDAsMSwzLjE4NCwzLjg2OGE0LjAxMiw0LjAxMiwwLDAsMSwxLjEyOC0yLjQ1QTQuOCw0LjgsMCwwLDEsNy43MTYsMGE0LjI2OCw0LjI2OCwwLDAsMSwzLjk0NiwyLjUwOXEuMTc2LS4wMTMuMzUzLS4wMTNBMy45NzgsMy45NzgsMCwwLDEsMTYsNi43MDZhNC4zOCw0LjM4LDAsMCwxLTEuMDc3LDIuOTRBNC4yNjYsNC4yNjYsMCwwLDEsMTEuNjM3LDExWiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgICA8ZyBpZD0i57yW57uEIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5IDIpIj4KICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIZfMTQyIiBjeD0iNSIgY3k9IjUiIHI9IjUiIGZpbGw9IiNmNmIwNGEiLz4KICAgICAgPC9nPgogICAgICA8ZyBpZD0i57yW57uELTIiIGRhdGEtbmFtZT0i57yW57uEIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5IDIpIj4KICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIZfMTQyLTIiIGRhdGEtbmFtZT0i5qSt5ZyGXzE0MiIgY3g9IjUiIGN5PSI1IiByPSI1IiBmaWxsPSIjMzI5YTFhIi8+CiAgICAgICAgPGcgaWQ9Iue7hF8xMzEwNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS44MDUgNS4zODEpIHJvdGF0ZSgtNDUpIj4KICAgICAgICAgIDxyZWN0IGlkPSLnn6nlvaJfMTMyNDAiIHdpZHRoPSI1LjMzMyIgaGVpZ2h0PSIwLjY2NyIgcng9IjAuMzMzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjQzOCAyLjYpIiBmaWxsPSIjZmJmYWZiIi8+CiAgICAgICAgICA8cmVjdCBpZD0i55+p5b2iXzE1NjI4IiB3aWR0aD0iMC43MTQiIGhlaWdodD0iMi43MTQiIHJ4PSIwLjM1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4yODYgMC4zMzMpIiBmaWxsPSIjZmJmYWZiIi8+CiAgICAgICAgPC9nPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };